export default "__VITE_ASSET__I$u7AMn1__"